import { css, cx } from 'linaria';
import { DiscoverFilledIcon } from 'components/icons/DiscoverFilledIcon';
import { buttonReset } from 'components/buttons/button-reset';
import { tagBase } from './tags';
const webOnlyWrapper = "whw7f9r";
export function WebOnlyTag({
  count,
  margin
}) {
  const className = cx(webOnlyWrapper, buttonReset, tagBase);
  return <div className={className} style={{
    margin
  }}>
      <DiscoverFilledIcon />
      <span>{count}</span>
    </div>;
}

require("./tag-web-only.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./tag-web-only.js");